import React from 'react';
import {Modal, Form, Input, Button} from 'antd';
import {b64DecodeUnicode} from '../utils'
const FormItem = Form.Item;
const {TextArea} = Input;

const GroupModalForm = Form.create()((props) => {
  const {
    title,
    group,
    groups,
    parent,
    visible,
    onCancel,
    onSubmit,
    form
  } = props;
  const info = group.MoreInfo
    ? JSON.parse(b64DecodeUnicode(group.MoreInfo))
    : {
      desc: ""
    }
  const formItemGroupParent = parent
    ? <FormItem label="Địa bàn lớn">
        <Input defaultValue={parent.Name} disabled={true}/>
      </FormItem>
    : null
  const fieldParentID = parent
    ? parent.ID
    : group.ParentID
  const {getFieldDecorator} = form;
  return (<Modal visible={visible} title={title} okText="Lưu" cancelText="Bỏ qua" onCancel={onCancel} onOk={onSubmit} footer={[
      <Button key="cancel" onClick={onCancel}>Bỏ qua</Button>,
      <Button key="submit" type="primary" ghost="ghost" onClick={onSubmit}>
        Lưu
      </Button>
    ]}>
    <Form layout="vertical">
      {getFieldDecorator('ID', {initialValue: group.ID})(<span/>)}
      {getFieldDecorator('ParentID', {initialValue: fieldParentID})(<span/>)}
      {formItemGroupParent}
      <FormItem label="Tên địa bàn">
        {
          getFieldDecorator('Name', {
            rules: [
              {
                required: true,
                message: 'Phải nhập tên địa bàn!'
              }, {
                validator: (rule, value, cb) => {
                  if (value) {
                    if (value !== group.Name) {
                      const index = groups.findIndex((item) => {
                        return item.Name === value
                      })
                      if (index > -1) {
                        cb("Địa bàn đã sử dụng!")
                      }
                    }
                  }
                  cb()
                }
              }
            ],
            initialValue: group.Name
          })(<Input/>)
        }
      </FormItem>
      <FormItem label="Mô tả">
        {getFieldDecorator('MoreInfo.desc', {initialValue: info.desc})(<TextArea/>)}
      </FormItem>
    </Form>
  </Modal>);
})

export default GroupModalForm



// WEBPACK FOOTER //
// ./src/components/GroupModalForm.js